module.exports = "/packs/careerchange_ survey-popup-b456bfdbe4aadf07cfa18cd0607cdbe1.jpg";